import Vue from 'vue'
import api from '@/api'
import Component from 'vue-class-component'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { SummarySection } from '@/interfaces/SummarySection'

@Component
export class PriceCalculator extends Vue {
  public calculatePrice(model: ProductApiModel): Promise<SummarySection[]> {
    return api
      .post('/products/' + model.code + '/price/', model.configurator)
      .then(response => {
        return response.data.summarySections
      })
      .catch(() => {
        return []
      })
  }
}
